import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTracking } from '@justgiving/react-tracking';
import classNames from 'classnames';

import { PageStatus } from '../../../types/__generated__';
import { useBasePageQuery, usePageMeta } from '../../hooks';
import { filterByTypename } from '../../utils/graphql';

import styles from './CampaignStartFundraising.scss';

export function CampaignStartFundraising() {
  const { t } = useTranslation('common', { useSuspense: false });
  const track = useTracking();
  const basePageData = useBasePageQuery();

  const { startFundraisingUrl, status, relationships } =
    basePageData?.data?.page ?? {};

  const beneficiaries = relationships?.beneficiaries;

  if (
    !beneficiaries ||
    beneficiaries.nodes.length === 0 ||
    !startFundraisingUrl
  ) {
    return null;
  }
  const charities = filterByTypename(beneficiaries.nodes, 'Charity');

  function handleOnClick(eventValue: string) {
    track({
      event: 'link click',
      subtype: 'button',
      event_value: eventValue,
      page_section: 'become a fundraiser',
    });
  }

  return (
    <section className={classNames(styles.container)}>
      <h2 className="jg-h4">{t('campaign.startFundraisingTitle')}</h2>
      {status === PageStatus.Completed ? (
        <ViewCharityProfile
          onClick={handleOnClick}
          link={`${charities[0].profilePageUrl}`}
        />
      ) : (
        <StartFundraising onClick={handleOnClick} link={startFundraisingUrl} />
      )}
    </section>
  );
}

interface ChildProps {
  onClick: (eventValue: string) => void;
  link: string;
}

function ViewCharityProfile({ onClick, link }: ChildProps) {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <>
      <p>{t('campaign.startFundraisingCompleted')}</p>
      <a
        className={classNames('jg-btn', 'jg-btn--ghost')}
        href={link}
        onClick={() => onClick('view charity profile')}
      >
        {t('campaign.startFundraisingCompletedCTA')}
      </a>
    </>
  );
}

function StartFundraising({ onClick, link }: ChildProps) {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isPreview } = usePageMeta();

  return (
    <>
      <p>{t('campaign.startFundraising')}</p>
      {isPreview ? (
        <button className={classNames('jg-btn', 'jg-btn--primary')}>
          {t('campaign.startFundraisingCTA')}
        </button>
      ) : (
        <a
          className={classNames('jg-btn', 'jg-btn--primary')}
          href={link}
          onClick={() => onClick('start fundraising')}
        >
          {t('campaign.startFundraisingCTA')}
        </a>
      )}
    </>
  );
}
